import { TTwoUtpBlock } from 'shared/types/utp';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

interface ITwoUtpBlockProps {
  blocks: TTwoUtpBlock;
}

export const TwoUtpBlock: React.FC<ITwoUtpBlockProps> = ({ blocks }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {blocks.map(({ title, notice, description, image }, key) => (
        <div className={styles['item']} key={key}>
          <div className={styles['title']}>{title}</div>
          {description && <div className={styles['description']}>{description}</div>}
          {notice && <div className={styles['notice']}>{notice}</div>}
          <div className={clsx(styles['image'], styles[image])} />
        </div>
      ))}
    </div>
  );
};
